import { css } from '@emotion/react';
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons';
import type { FC } from 'react';
import { FontAwesomeIcon } from '~/_shared/baseComponents/icon/fontAwesomeIcon.component';

export const caretStyle = css({
  fontWeight: 900,
  fontSize: '16px',
  lineHeight: '24px',
  transition: 'transform .2s',
  ['[data-element="accordion-item"][open] > [data-element="accordion-heading"] > &']: {
    transform: 'rotate(180deg)',
  },
  ['[data-element="accordion-item"][data-is-locked] > [data-element="accordion-heading"] > &']: {
    display: 'none',
  },
});

export const AccordionCaret: FC = (props) => {
  return (
    <FontAwesomeIcon
      data-element="accordion-item-caret"
      {...props}
      css={caretStyle}
      icon={faCaretDown}
    />
  );
};
